import React from "react";

import "./Logo.css";

export const Lingo3GLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    version="1.1"
    className="Lingo3GLogo Logo"
    fill="#1D3557"
  >
    Lingo3G
    <g transform="matrix(1.77 0 0 1.77 -88.51 -1126)">
      <path
        d="m140 245c-49.71 0-90 40.29-90 90s40.29 90 90 90 90-40.29 90-90-40.29-90-90-90zm0 10c44.18 0 80 35.82 80 80s-35.82 80-80 80-80-35.82-80-80 35.82-80 80-80z"
        fillOpacity=".5020"
        transform="translate(0 477.4)"
        fill="#fff"
      />
      <path
        d="m267.7 181c0 51.88-42.06 93.94-93.94 93.94s-93.94-42.06-93.94-93.94 42.06-93.94 93.94-93.94 93.94 42.06 93.94 93.94z"
        fillOpacity=".2980"
        transform="matrix(.8516 0 0 .8516 -7.957 658.2)"
      />
      <path
        d="m140 245c-49.71 0-90 40.29-90 90s40.29 90 90 90 90-40.29 90-90-40.29-90-90-90zm0 10c44.18 0 80 35.82 80 80s-35.82 80-80 80-80-35.82-80-80 35.82-80 80-80z"
        fillOpacity=".5020"
        transform="translate(50 391.4)"
        fill="#fff"
      />
      <path
        d="m267.7 181c0 51.88-42.06 93.94-93.94 93.94s-93.94-42.06-93.94-93.94 42.06-93.94 93.94-93.94 93.94 42.06 93.94 93.94z"
        fillOpacity=".4980"
        transform="matrix(.8516 0 0 .8516 42.04 572.2)"
      />
      <g transform="translate(100)">
        <path
          d="m140 245c-49.71 0-90 40.29-90 90s40.29 90 90 90 90-40.29 90-90-40.29-90-90-90zm0 10c44.18 0 80 35.82 80 80s-35.82 80-80 80-80-35.82-80-80 35.82-80 80-80z"
          fillOpacity=".6275"
          transform="translate(0 477.4)"
          fill="#fff"
        />
        <path
          d="m267.7 181c0 51.88-42.06 93.94-93.94 93.94s-93.94-42.06-93.94-93.94 42.06-93.94 93.94-93.94 93.94 42.06 93.94 93.94z"
          fillOpacity=".8"
          transform="matrix(.8516 0 0 .8516 -7.957 658.2)"
        />
      </g>
    </g>
  </svg>
);
